import React, { createContext, useContext, useState, useEffect } from 'react';
import apiServiceInv from '../services/apiService'; 

const CurrencyContext = createContext();

export const CurrencyProvider = ({ children }) => {
  const [currencyPrecision, setCurrencyPrecision] = useState(); 

  const handleCurrencies = async () => {
    try {
      const res = await apiServiceInv.get('GET_CURRENCY_PER');
      const currencyPrecision = res?.data?.data?.defaultCurrencyPrecision || 4;
      setCurrencyPrecision(currencyPrecision || 4);
    } catch (error) {
      console.error('Failed to fetch currency precision', error);
    }
  };

  useEffect(() => {
    handleCurrencies();
  }, []);

  return (
    <CurrencyContext.Provider value={{ currencyPrecision, setCurrencyPrecision }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);